import Vue from 'vue';
import Router from 'vue-router';
import store from './store'


const baseRoutes = [
	{	path: '/login',		name: 'Login',		component: () => import( '@/views/auth/Login') },
    {	path: '/logout',	name: 'Logout',		component: () => import( '@/views/auth/Logout') },
    {	path: '/register',	name: 'Register',	component: () => import( '@/views/auth/Register') },
    {	path: '/password-change',	name: 'PasswordChange',	component: () => import( '@/views/auth/PasswordChange') },
    {	path: '/forgot-password',	name: 'ForgotPassword',	component: () => import( '@/views/auth/ForgotPassword') },
    {	path: '/',			name: 'Dashboard',	meta: { requiresAuth: true },	component: () => import( '@/views/dispensations/Dispense') },
    {	path: '*',			redirect: '/' }
]

const loadedRoutes = loadRoutes()
const routes = baseRoutes.concat(...loadedRoutes)

Vue.use(Router);

let router = new Router({
  mode: 'history',
  routes,
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    
    if (store.getters.isAuthenticated) {
      next()
      return
    }
    next('/login')
  } else {
    next()
  }
})

function loadRoutes() {
	const context = require.context('@/views/', true, /\.js$/)
	return context.keys().map(context).map(m => m.default)
}

export default router;
